import axios from 'axios'
import { Message, Loading } from 'element-ui';
let loading;
let loadingNum = 0; //  内存中正在请求的数量

function startLoading() {
	if (loadingNum == 0) {

		loading = Loading.service({
			lock: true,
			text: '拼命加载中...',
			background: 'rgba(255,255,255,0.5)',
			target: document.querySelector('.content,.content1'),
		})
	}
	loadingNum++;
}

function endLoading() { //  关闭加载动画
	loadingNum--;
	if (loadingNum <= 0) {
		loading.close();
	}
}

const service = axios.create({
	baseURL: process.env.API_ROOT,
	responseType: 'json',
	withCredentials: true,
	// 超时时间 单位是ms，这里设置了3s的超时时间
	timeout: 3*60 * 1000
})
service.interceptors.request.use(
	config => {
		// startLoading(); //  打开加载动画
		config.headers = {
			'Accept': 'application/json, text/plain, */*' //配置请求头
		}
		if(config.params&&config.params.perpage){
			config.params['limit'] = config.params.perpage;
		}
		// console.log(config)
		return config
	}, error => {
		Promise.reject(error)
	}
)

// 3.响应拦截器
service.interceptors.response.use(
	response => {
		// endLoading();
		if(response.config.responseType=='blob'){
			return Promise.resolve(response.data)
		}else{
			if (response.status == 200) {
				if (response.data.code == 0) {
					return Promise.resolve(response.data)
				} else {
					return Promise.reject(response.msg)
				}
			}
		}
	}, error => {
		// endLoading();
	}
)
export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js